// extracted by css-extract-rspack-plugin
export default {"list":"list-McdtlM","item":"item-j5psDf","info":"info-rvsEkW"};